/**
 * Mapeamento nome do documento (card Protocolos e Documentos) -> tipo_protocolo do backend.
 */
export const DOCUMENTO_TO_TIPO_PROTOCOLO: Record<string, string> = {
  'Identificação do Paciente': 'identificacao_paciente',
  'Triagem': 'triagem',
  'Prontuário Geralista': 'prontuario_geralista',
  'Consulta Oftalmológica': 'consulta_oftalmologica',
  'Prontuário Retinólogo': 'prontuario_retinologo',
  'Avaliação Cardiológica (Escore Lee)': 'avaliacao_cardiologica',
  'Anamnese Pré-Operatória': 'anamnese_pre_operatoria',
  'Encaminhamento Cirurgico': 'encaminhamento_cirurgico',
  'Encaminhamento Cirúrgico': 'encaminhamento_cirurgico'
}

export function getTipoProtocolo(documentName: string): string | undefined {
  return DOCUMENTO_TO_TIPO_PROTOCOLO[documentName]
}
